import React, { Component } from 'react';
import { Typography, withTheme } from 'material-ui';

class Message extends Component {
  render() {
    return(//TODO add calc to marginTop
      <Typography variant='display1' style={{ marginTop: '35vh', textAlign: 'center'}}>
        {this.props.children}
      </Typography>
    );
  }
}

export default withTheme()(Message);


// WEBPACK FOOTER //
// ./src/components/Message.js